import Skeleton from '../skeleton/skeleton';
import { randomWeight } from '../utils/number.utils';

const CollapsableMessagesSkeleton = () => {
    return (
        <div className="flex items-center space-x-2">
            <Skeleton height={32} width={32} circle={true} />
            <div className="flex-grow">
                <Skeleton height={24} width={`${randomWeight(50, 90)}%`} />
            </div>
        </div>
    );
};

export default CollapsableMessagesSkeleton;
